import { createFileRoute } from "@tanstack/react-router";
import { LanguageScreen } from "@ui/screens/LanguageScreen";

export const Route = createFileRoute("/language")({
  component: LanguageScreen,
});
